import React, { Component } from 'react';
import './VehicleServices.css';

import { Select } from 'antd';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames';

@inject('translationsStore', 'step3RegistrationStore', 'registrationStore')
@observer
export default class VehicleServices extends Component {
  setFormField = field => value => {
    this.props.step3RegistrationStore.setFormField(field, value);
  };

  render() {
    const {
      step3RegistrationStore,
      disabled,
      translationsStore: { current: t }
    } = this.props;

    const cls = classNames({
      VehicleServices: true,
      [this.props.className]: !!this.props.className,
      disabled
    });

    return (
      <div className={cls}>
        <div className="variantSelector">
          <div>{t['registration_3']['maintenances']['service']['variant']}</div>
          <Select disabled={disabled} value={step3RegistrationStore.formValues.maintenances.servicing.variant} onChange={this.setFormField('maintenances.servicing.variant')}>
            {step3RegistrationStore.servicing.variants.map((variant, index) => (
              <Select.Option key={`variant_${index}`} value={variant.LinkId}>
                {variant.Desc}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_3/VehicleServices/VehicleServices.js